// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Settings$Showside from "../types/Settings.bs.js";
import * as WebapiUtils$Showside from "../utils/WebapiUtils.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as GlobalScrollRestoration$Showside from "../utils/GlobalScrollRestoration.bs.js";
import * as StickyHeaderOffsetProvider$Showside from "../context/StickyHeaderOffsetProvider.bs.js";
function useInlineHelper(embedContainer, embedHeight, embedOffsetTop) {
  var siteHeaderHeight = StickyHeaderOffsetProvider$Showside.useStrict(undefined);
  var match = ConfigurationProvider$Showside.use(undefined).config;
  var account = match.transitiveAccount;
  var settings = match.settings;
  GlobalScrollRestoration$Showside.useGlobalScrollRestoration("global-" + match.id, Belt_Option.map(embedOffsetTop, function (embedOffsetTop) {
    return Math.max(embedOffsetTop - siteHeaderHeight | 0, 0);
  }), embedHeight, undefined);
  var resetOverflowOnAncestorElements = function (el) {
    var parent = Caml_option.nullable_to_opt(el.parentElement);
    while (Belt_Option.isSome(parent)) {
      var computedStyles = Belt_Option.map(parent, function (el) {
        return window.getComputedStyle(el);
      });
      var overflow = Belt_Option.map(computedStyles, function (styles) {
        return styles.overflow;
      });
      if (Caml_obj.notequal(overflow, "visible") && Caml_obj.notequal(overflow, "visible visible")) {
        Belt_Option.forEach(parent, function (el) {
          WebapiUtils$Showside.setStyle(el, "overflow", "clip visible");
        });
      }
      parent = Belt_Option.flatMap(parent, function (prim) {
        return Caml_option.nullable_to_opt(prim.parentElement);
      });
    }
    ;
  };
  React.useEffect(function () {
    var match = Settings$Showside.getSiteHeaderCSSSelector(settings, account);
    if (embedContainer !== undefined && match !== undefined) {
      resetOverflowOnAncestorElements(Caml_option.valFromOption(embedContainer));
    }
  }, [embedContainer]);
}
export { useInlineHelper };
/* react Not a pure module */